module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"goToBooking":"Go to booking link","scheduledEmptyLabel":"Appointment is scheduled","cancelledEmptyLabel":"Appointment is cancelled","appointmentScheduledForUser":"Any of {userName}\u0027s appointments are scheduled","appointmentCancelledForUser":"Any of {userName}\u0027s appointments are cancelled","invalidUser":"Invalid user","error":"Please select an appointment type"}}')
  delete Component.options._Ctor
}
